{
  "AGENT_BOTS": {
    "HEADER": "Boți",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "Bot de sistem",
    "GLOBAL_BOT_BADGE": "Sistem",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatarul botului a fost șters cu succes",
      "ERROR_DELETE": "Eroare la ștergerea avatarului botului, vă rugăm să încercați din nou"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Selectați un bot de agent",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Actualizare",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "A actualizat cu succes botul agentului.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Deconectat cu succes botul agentului.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Boți pe țări",
        "DESC": "Această căsuță deservește mai multe țări. O conversație ajunge la botul țării sale: în funcție de magazinul Kaufland, de piața comenzii Allegro sau, în lipsă, de limba în care scrie clientul. Toate celelalte conversații ajung la botul implicit de mai sus.",
        "COUNTRY": "Selectați o țară",
        "BOT": "Selectați botul",
        "ADD": "Adaugă bot pentru o țară",
        "REMOVE": "Elimină",
        "DEFAULT_REQUIRED": "Selectați mai întâi un bot implicit. Botul unei țări îl înlocuiește doar pentru acea țară.",
        "DISCONNECT_ALL": "Deconectează toți boții"
      }
    },
    "ADD": {
      "TITLE": "Configurați un bot nou",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "API": {
        "SUCCESS_MESSAGE": "Bot adăugat cu succes.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Detalii bot",
        "URL": "URL webhook"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți {name}?",
        "YES": "Da, șterge",
        "NO": "Nu, păstrează"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent sters cu succes.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      },
      "SUBMIT": "Şterge",
      "CANCEL_BUTTON_TEXT": "Renunță",
      "DESCRIPTION": "Sunteți sigur că doriți să ștergeți acest bot? Această acțiune este ireversibilă."
    },
    "EDIT": {
      "BUTTON_TEXT": "Editare",
      "TITLE": "Edit bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot actualizat cu succes.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      },
      "LOADING": "Fetching bots...",
      "CANCEL_BUTTON_TEXT": "Renunță"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar bot"
      },
      "NAME": {
        "LABEL": "Nume bot",
        "PLACEHOLDER": "Introduceți numele botului",
        "REQUIRED": "Numele botului este obligatoriu"
      },
      "DESCRIPTION": {
        "LABEL": "Descriere",
        "PLACEHOLDER": "Ce face acest bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL-ul webhook este obligatoriu"
      },
      "ERRORS": {
        "NAME": "Numele botului este obligatoriu",
        "URL": "URL-ul webhook este obligatoriu",
        "VALID_URL": "Vă rugăm să introduceți un URL valid care începe cu http:// sau https://"
      },
      "CANCEL": "Anulează",
      "CREATE": "Creează bot",
      "UPDATE": "Actualizează bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configurați un bot webhook pentru a integra cu serviciile dumneavoastră personalizate. Botul va primi și procesa evenimente din conversații și poate răspunde la ele."
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Numele botului este necesar."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "Ce face acest bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Vă rugăm să introduceți configurația bot CSML de mai sus.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validați și salvați"
    }
  }
}
